// extracted by css-extract-rspack-plugin
export default {"container":"container--Loc0maf3HGsy4Meq"};